import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{attrs:{"dense":""}},[_c(VCol,{staticClass:"mt-1",attrs:{"cols":"12"}},[_c('schedule-as-soon-as-posible',{model:{value:(_vm.deliveryTime),callback:function ($$v) {_vm.deliveryTime=$$v},expression:"deliveryTime"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }